export enum SubOrderType {
  TAKE_AWAY = 'take_away',
  INSIDE = 'inside',
  DELIVERY = 'delivery',
  PARK_COLLECT = 'park_collect',
  PICKUP_BOX = 'pickup_box',
  DRIVE = 'drive',
  FOODSPOT = 'foodspot',
}
